import type {PathMap} from '../../utils/mapFields'

export interface ScopedDataItem {
    breakpoint?: string
    displayMode?: string
    clickAction?: string
    cropMask?: {svgId: string; rotate: number; flip: string}
    type?: string
}

export const URL_PARAM_TO_PATH = {width: 'data.image.width', height: 'data.image.height'}
export const IMAGEX_CUSTOM_DESIGN_TYPE = 'ImageXCustomDesign'

export const getDefaultCropMaskMapping: (defaultDesignPath: string) => PathMap = (defaultDesignPath: string) => {
    return {
        'data.mask.svgId': `${defaultDesignPath}.crop.svgId`,
        'data.mask.rotate': `${defaultDesignPath}.crop.rotate`,
        'data.mask.flip': `${defaultDesignPath}.crop.flip`
    }
}

export const getFieldMapping: (defaultDesignPath: string) => PathMap = (defaultDesignPath: string) => {
    return {
        'data.image.uri': 'src',
        'data.image.alt': 'alt',
        'data.image.name': 'name',
        ...getDefaultCropMaskMapping(defaultDesignPath),
        [`${defaultDesignPath}.displayMode`]: 'displayMode',
        [`${defaultDesignPath}.clickAction`]: 'onClickBehavior'
    }
}

export const SCOPED_DATA: PathMap = {
    'crop.svgId': 'cropMask.svgId',
    'crop.rotate': 'cropMask.rotate',
    'crop.flip': 'cropMask.flip'
}
